import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // "success", "error", "warning", "info"
  });

  useEffect(() => {
    emailjs.init("cG1b0dHTDVoknlvnR"); // Replace with your EmailJS Public Key
  }, []);

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setSnackbar({
        open: true,
        message: "Please enter a valid email address.",
        severity: "error",
      });
      return;
    }

    // Use EmailJS to send the email
    const templateParams = {
      from_email: "admin@pixell.in",
      user_email: email, // Email the user entered
      message: "Thank you for subscribing!", // Your message or any content
    };

    emailjs
      .send(
        "service_eee3j4z", // Replace with your EmailJS Service ID
        "template_thb8hyf", // Replace with your EmailJS Template ID
        templateParams,
        "cG1b0dHTDVoknlvnR",
      )
      .then(
        () => {
          setEmail("");
          setSnackbar({
            open: true,
            message:
              "You have successfully subscribed! A confirmation email has been sent.",
            severity: "success",
          });
        },
        (error) => {
          console.error("Failed to send email:", error);
          setSnackbar({
            open: true,
            message: "Something went wrong. Please try again.",
            severity: "error",
          });
        },
      );
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <footer className="bg-black text-white pt-20 pb-10 px-10">
      <div className="container xl:max-w-6xl mx-auto px-4">
        {/* Main Content */}
        <div className="text-center md:text-left">
          <h2 className="text-xl md:text-5xl font-bold text-white">
            Manage Your Retail Branding Campaigns <br /> Like Never Before.
          </h2>
          {/* <form onSubmit={handleSubmit} className="mt-6 flex flex-col md:flex-row md:items-center md:justify-start justify-center">
            <input
              type="email"
              value={email}
              onChange={handleInputChange}
              placeholder="Enter your email"
              className="w-full md:w-1/3 p-2 rounded-md text-black border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="submit"
              className="mt-4 md:mt-0 md:ml-4 px-6 py-2 bg-blue-500 rounded-md hover:bg-blue-600 transition duration-200"
            >
              Subscribe
            </button>
          </form> */}
          {/* Snackbar Component */}
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity={snackbar.severity}
              sx={{ width: "100%" }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        </div>

        {/* Links */}
        <div className="my-10 flex flex-wrap justify-center md:justify-between text-gray-400 text-sm">
          <div className="flex space-x-4 mb-4 md:mb-0">
            {/* <Link to="#" className="text-gray-400 hover:text-white">
              About Us
            </Link> */}

            <Link to="/" className="text-gray-400 hover:text-white">
              Clients
            </Link>
            <Link to="/vendor" className="text-gray-400 hover:text-white">
              Vendor Partners
            </Link>
            <Link to="/ip" className="text-gray-400 hover:text-white">
              Installation Partners
            </Link>
            {/* <Link to="/aboutus" className="text-gray-400 hover:text-white">
              About Us
            </Link> */}
            <Link to="/ContactUs" className="text-gray-400 hover:text-white">
              Contact Us
            </Link>
            <Link to="/blogs" className="text-gray-400 hover:text-white">
              Blogs
            </Link>
          </div>
          <div className="flex space-x-8">
            {/* <Link to="#" className="text-gray-400 hover:text-white">
              Jobs
            </Link> */}
            <Link
              to="/term&condition"
              className="text-gray-400 hover:text-white"
            >
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="text-gray-400 hover:text-white">
              Privacy Policy
            </Link>
          </div>
        </div>
        <hr />
        {/* Footer Bottom */}
        <div className="mt-10 text-center text-gray-500">
          &copy; 2026 Pixell | Signthought Solutions Private Limited . All
          rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
